import { render, staticRenderFns } from "./RecruitIndex.vue?vue&type=template&id=45c151a6&scoped=true"
import script from "./RecruitIndex.vue?vue&type=script&lang=js"
export * from "./RecruitIndex.vue?vue&type=script&lang=js"
import style0 from "./RecruitIndex.vue?vue&type=style&index=0&id=45c151a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c151a6",
  null
  
)

export default component.exports